import React, { useEffect, useState } from 'react';
import PlatformPage from '@/components/Platform';
import { Layout } from '@/components/Common';
import { NextPageWithLayout } from '@/pages/_app';
import {
  SALES_AND_MARKETING_CONTENT,
  SALES_AND_MARKETING_HEADER_CONTENT,
} from '@/shared/constants/platform-pages-constants';
import { SEO_META } from '@/shared/seo';
import { SEO_META_PAGES } from '@/shared/types/seo';
import { WEBSITE_URL, STATIC_FILE_URL } from '@/shared/constants';
import { EventSource } from '@/shared/constants/event';
import { logCommonView, logPageView } from '@/lib/service';
import CustomHead from '@/components/Common/Layout/Head';
import PlatformHeader from '@/components/Platform/PlatformHeader';
import { useRouter } from 'next/router';
import cN from 'classnames';
import { BrandVideos, Trustpilot } from '@/components/Home';
import { HOME_PAGE_BRAND_VIDEO_LIST } from '@/shared/constants/landing-pages';
import FeaturedIn from '@/components/ExistingBrandsLandingPage/FeaturedIn';
import ExpandYourSalesAndMarketing from '@/components/Platform/ExpandYourRetailNetwork';
import './index.less';
import PlatformSalesAndMarketing from '@/components/Platform/PlatformSalesAndMarketing';

const IdeationPage = ({}: NextPageWithLayout<any>) => {
  const router = useRouter();
  const [email, setEmail] = useState<string>('');

  const handleStart = () => {
    if (email) {
      logCommonView(EventSource.SALES_AND_MARKETING_SIGNUP_FORM, email);
      router.push({ pathname: '/sell-on-pietra/register', query: { email } });
      return;
    }
    router.push({ pathname: '/sell-on-pietra/register' });
  };

  useEffect(() => {
    logPageView({
      pageUrl: window.location.href || '',
      routeName: window.location.pathname,
      pageTitle: `Sales & Marketing | Pietra`,
    });
  }, []);

  return (
    <>
      <PlatformHeader
        content={SALES_AND_MARKETING_HEADER_CONTENT}
        customTitle={
          <h1 className={cN('title', SALES_AND_MARKETING_HEADER_CONTENT?.titleClass)}>
            <span className="green-text" data-text="A marketing suite">
              A marketing suite
            </span>
            <span className="black-text"> to help grow sales without the overhead.</span>
          </h1>
        }
        customActionBtn={
          <div className="sales-and-marketing-custom-action-btn-container">
            <input
              type="text"
              placeholder="Enter your email"
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleStart();
                }
              }}
            />
            <button className="action-btn-container" onClick={handleStart}>
              <span>Get started</span>
            </button>
          </div>
        }
        customHero={
          <PlatformSalesAndMarketing
            className="hero-banner-container"
            title={SALES_AND_MARKETING_HEADER_CONTENT.heroTitle}
          />
        }
      />
      <div className="sales-and-marketing-rating-wrap">
        <Trustpilot />
      </div>
      <BrandVideos
        className="platform-brand-video-container"
        brandTitle="300,000+ brands & entrepreneurs choose Pietra"
        brandList={HOME_PAGE_BRAND_VIDEO_LIST}
      />
      <FeaturedIn />
      <ExpandYourSalesAndMarketing
        title="A marketing suite designed for e-commerce"
        description="Stop paying full price for marketing software and services. Save tens of thousands of dollars each month with Pietra."
        btnText="Start for free"
        customStyle={{ background: 'radial-gradient(533.78% 172.54% at 1.86% -0.09%, #4DC523 0%, #10BF9C 100%)' }}
      />
      <PlatformPage content={SALES_AND_MARKETING_CONTENT} utmSource="sales_and_marketing" />
    </>
  );
};

IdeationPage.getLayout = (page: React.ReactElement) => {
  return (
    <>
      <CustomHead
        title="Sales & Marketing | Pietra"
        description="Instantly add 200+ sales channels, access popular e-commerce software for free, and offload CX and paid marketing to Pietra."
        url={`${WEBSITE_URL}/platform/sales-and-marketing`}
        image={`${STATIC_FILE_URL}/81c5f487848fe869a10d353b462f9558.png`}
      />
      <Layout
        structured={SEO_META[SEO_META_PAGES.IDEATION].jsonld({
          url: typeof window === 'object' ? window.location.href : '',
        })}
      >
        {page}
      </Layout>
    </>
  );
};

export default IdeationPage;
